<template>
  <div>
    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{item}">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <template v-slot:item.date="{item}">{{item.date | dateFormat}}</template>
      <template v-slot:item.sDate="{item}">{{item.sDate | dateFormat}}</template>
      <template v-slot:item.eDate="{item}">{{item.eDate | dateFormat}}</template>
      <template v-slot:item.attachment="{item}">
        <slot name="attachment" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/educBackground";
export default {
  props: {
    empCode: {
      default: null,
      type: String
    }
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "School",
        value: "schoolDesc",
        sortable: false
      },
      {
        text: "Other School",
        value: "otherSchool",
        sortable: false
      },
      {
        text: "Address",
        value: "address",
        sortable: true
      },
      {
        text: "School Country",
        value: "countryDesc",
        sortable: true
      },
      {
        text: "Level",
        value: "educLevel",
        sortable: true
      },
      {
        text: "Educ. Attainment",
        value: "eduAttDesc",
        sortable: true
      },
       {
        text: "Educ. Establishment",
        value: "eduEstDesc",
        sortable: true
      },
      {
        text: "Course",
        value: "courseDesc",
        sortable: true
      },
      {
        text: "Major",
        value: "majorDesc",
        sortable: true
      },
      {
        text: "Final Grade",
        value: "finalGrade",
        sortable: true
      },
      {
        text: "From",
        value: "yearFr",
        sortable: true
      },
      {
        text: "To",
        value: "yearTo",
        sortable: true
      },
      {
        text: "Start Date",
        value: "sDate",
        sortable: true
      },
      {
        text: "End Date",
        value: "eDate",
        sortable: true
      },
      {
        text: "License Number",
        value: "licenseNumber",
        sortable: true
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: true
      },
      {
        text: "Attachment",
        value: "attachment",
        sortable: false
      }
    ]
  }),
  methods: {
    getByEmpCode(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${empCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.success(response.data.message);
        });
    }
  },
  created() {
    this.getByEmpCode(this.empCode);
  },
  watch: {
    empCode(val) {
      this.getByEmpCode(val);
    }
  }
};
</script>